// extracted by mini-css-extract-plugin
export var root = "RecentPosts-root-thzcx";
export var rootCol = "RecentPosts-root_col-R9wA-";
export var rootHeading = "RecentPosts-root_heading-pIfK2";
export var rootLightGray = "RecentPosts-root-lightGray-PObD0";
export var rootRow = "RecentPosts-root_row-IIQBh";
export var rootWrapper = "RecentPosts-root_wrapper-fvjg8";